var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkGrayInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.792C10.3455 14.792 10.6253 14.5122 10.6253 14.167V9.16699C10.6253 8.82182 10.3455 8.54199 10.0003 8.54199C9.65515 8.54199 9.37533 8.82182 9.37533 9.16699V14.167C9.37533 14.5122 9.65515 14.792 10.0003 14.792Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 5.83366C10.4606 5.83366 10.8337 6.20676 10.8337 6.66699C10.8337 7.12723 10.4606 7.50033 10.0003 7.50033C9.54009 7.50033 9.16699 7.12723 9.16699 6.66699C9.16699 6.20676 9.54009 5.83366 10.0003 5.83366Z",
    fill: "#5A5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04199 10.0003C1.04199 5.05277 5.05277 1.04199 10.0003 1.04199C14.9479 1.04199 18.9587 5.05277 18.9587 10.0003C18.9587 14.9479 14.9479 18.9587 10.0003 18.9587C5.05277 18.9587 1.04199 14.9479 1.04199 10.0003ZM10.0003 2.29199C5.74313 2.29199 2.29199 5.74313 2.29199 10.0003C2.29199 14.2575 5.74313 17.7087 10.0003 17.7087C14.2575 17.7087 17.7087 14.2575 17.7087 10.0003C17.7087 5.74313 14.2575 2.29199 10.0003 2.29199Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGrayInfo);
export default __webpack_public_path__ + "static/media/darkGrayInfo.d11f24e1ed27bf8e65491553ec1cbaba.svg";
export { ForwardRef as ReactComponent };